import Hero from './components/Hero';
import Problems from './components/Problems';
import Promises from './components/Promises';
import Strengths from './components/Strengths';
import Staff from './components/Staff';
import Testimonials from './components/Testimonials';
import Gallery from './components/Gallery';
import Commitment from './components/Commitment';
import CTA from './components/CTA';
import Footer from './components/Footer';
import FixedCTA from './components/FixedCTA';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <Problems />
      <Promises />
      <Strengths />
      <Staff />
      <Testimonials />
      <Gallery />
      <Commitment />
      <CTA />
      <Footer />
      <FixedCTA />
    </div>
  );
}
